import React from 'react';
// scss
import './UsersList.scss';

const UsersItem = ({ data, idx, onUserChange }) => {
  const { user_id, name, phone, active } = data ?? {};
  const userStatus = active ? 'Активний' : 'Не активний';

  return (
    <li className="users__item user">
      <div className="user__box-name-status">
        <div className='user__name-wrap'>
          <span className="user__number">{idx + 1}</span>
          <span className="user__name">{name}</span>
          <span className="user__phone">{phone}</span>
        </div>
        <div className="user__status-wrap">
          <span className={`user__status ${active ? '' : 'disabled'}`}> {userStatus} </span>
          <div className="user__toggle">
            <input type="checkbox" id={user_id} checked={active} onChange={() => onUserChange(data, "status")} />
            <label htmlFor={user_id}></label>
          </div>
        </div>
      </div>
      <div className="user__btn-wrap">
        <button className="user__btn--edit-psw" type="button" onClick={() => onUserChange(data, "password")} > Змінити пароль </button>
        <button className="user__btn--edit-name" type="button" onClick={() => onUserChange(data, "name")}> Змінити iм'я </button>
        <button className="user__btn--delete" type="button" onClick={() => onUserChange(data, "delete")}>
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none" >
            <path d="M20 7.5V6.5C20 5.09987 20 4.3998 19.7275 3.86502C19.4878 3.39462 19.1054 3.01217 18.635 2.77248C18.1002 2.5 17.4001 2.5 16 2.5H14C12.5999 2.5 11.8998 2.5 11.365 2.77248C10.8946 3.01217 10.5122 3.39462 10.2725 3.86502C10 4.3998 10 5.09987 10 6.5V7.5M12.5 14.375V20.625M17.5 14.375V20.625M3.75 7.5H26.25M23.75 7.5V21.5C23.75 23.6002 23.75 24.6503 23.3413 25.4525C22.9817 26.1581 22.4081 26.7317 21.7025 27.0913C20.9003 27.5 19.8502 27.5 17.75 27.5H12.25C10.1498 27.5 9.0997 27.5 8.29754 27.0913C7.59193 26.7317 7.01825 26.1581 6.65873 25.4525C6.25 24.6503 6.25 23.6002 6.25 21.5V7.5" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Видалити
        </button>
      </div>
    </li>
  );
};

export default UsersItem;
